import AppButton from "@toothfairy/shared-ui/AppButton";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import { useEffect } from "react";
import { StyleSheet, View } from "react-native";
import Constants from "../../../Constants";
import DateFilter from "./Leafs/DateFilter";
import OperationsFilter from "./Leafs/OperationsFilter";
import ToothFairySwitch from "../../../Components/ToothFairyComponents/ToothFairySwitch";

const HumanFeedbackFilter = ({
  startDate,
  endDate,
  onUpdateEndDate,
  onUpdateStartDate,
  triggerFetchLogs,
  selectedServiceType,
  selectedFilterLimit,
  setSelectedFilterLimit,
  setSelectedServiceType,
  showDates,
  showIncludeResolved,
  setIncludeResolved,
  includeResolved,
  handleSearchMessage,
  messageText,
  setMessageText,
}) => {
  const { currentTheme } = AppTheme.useTheme();

  // Auto-search effect that triggers when any filter changes
  useEffect(() => {
    triggerFetchLogs();
  }, [
    startDate,
    endDate,
    selectedServiceType,
    selectedFilterLimit,
    includeResolved,
  ]);

  // Separate effect for message search to handle it properly
  useEffect(() => {
    if (handleSearchMessage) {
      handleSearchMessage(messageText);
    }
  }, [messageText, handleSearchMessage]);

  return (
    <View
      style={{
        backgroundColor: currentTheme?.theme?.softBackgroundColor,
        padding: 10,
      }}
    >
      <View style={{ maxWidth: 800 }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <AppTextInput
            onChangeText={setMessageText}
            style={{
              flex: 1,
              marginRight: 10,
              minWidth: 330,
            }}
            wrapperStyle={{}}
            placeholder="Search by message content..."
          />
        </View>
        {showDates && (
          <DateFilter
            startDate={startDate}
            endDate={endDate}
            onUpdateEndDate={onUpdateEndDate}
            onUpdateStartDate={onUpdateStartDate}
          />
        )}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <OperationsFilter
            items={[
              {
                label: "All",
                service: "",
              },
              {
                label: "Multi Language",
                service: "multilanguage",
              },
              {
                label: "Documentation",
                service: "documentation",
              },
              {
                label: "Reasoning",
                service: "reasoning",
              },
              {
                label: "Images extraction",
                service: "images",
              },
              {
                label: "Charts generation",
                service: "charting",
              },
              {
                label: "Live data",
                service: "api",
              },
            ]}
            propertyLabel="label"
            label="Type"
            selectedServiceType={selectedServiceType}
            setSelectedServiceType={setSelectedServiceType}
            selectedFilterLimit={selectedFilterLimit}
            setSelectedFilterLimit={setSelectedFilterLimit}
            minWidth={150}
            textAlign="flex-start"
          />
          {showIncludeResolved && (
            <ToothFairySwitch
              wrapperStyle={{
                maxWidth: 280,
                marginLeft: 5,
                backgroundColor: currentTheme?.theme?.inputBackgroundColor,
              }}
              label={"Show resolved"}
              onChange={(v) => {
                setIncludeResolved(v);
              }}
              isTicked={includeResolved}
            />
          )}
        </View>
      </View>
    </View>
  );
};

const styleGenerator = (currentTheme) => {
  return StyleSheet.create({
    button: {
      marginBottom: 5,
      height: Constants.appButtonHeight,
      width: 200,
      marginLeft: "auto",
      marginRight: "auto",
    },
    buttonLabel: {
      fontSize: currentTheme?.theme?.small_font_size,
    },
  });
};

export default HumanFeedbackFilter;
